export default __webpack_public_path__ + "static/media/SilverFoilRocket_08.cda59786.png";